(() => {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  const feeds = new Map();
  function initialize(scope) {
    scope.querySelectorAll('[data-collection-feed]').forEach(feed => {
      if (feeds.has(feed) || feed.dataset.autoLoad === 'false') return;
      const grid = feed.querySelector('[data-collection-grid]');
      const footer = feed.querySelector('[data-collection-scroll]');
      const status = feed.querySelector('[data-collection-status]');
      const retry = feed.querySelector('[data-collection-retry]');
      const link = feed.querySelector('[data-collection-next]');
      if (!link) return;
      let next = link.href, loading = false, disposed = false, controller;
      const visited = new Set();
      function pageUrl(value) {
        const url = new URL(value, window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) throw new Error('Invalid collection URL');
        url.searchParams.delete('section_id');
        url.hash = '';
        return url;
      }
      async function load() {
        if (loading || !next || disposed) return;
        loading = true;
        observer.unobserve(footer);
        retry.hidden = true;
        footer.setAttribute('aria-busy', 'true');
        status.textContent = 'Carregando mais produtos…';
        controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        let succeeded = false;
        try {
          const url = pageUrl(next);
          if (visited.has(url.href)) throw new Error('Repeated collection page');
          const requestUrl = new URL(url);
          requestUrl.searchParams.set('section_id', feed.dataset.sectionId);
          const response = await fetch(requestUrl.href, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Collection request failed');
          const documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (disposed || controller.signal.aborted) return;
          const incoming = [...documentPage.querySelectorAll('[data-collection-feed]')].find(node => node.dataset.sectionId === feed.dataset.sectionId);
          const incomingGrid = incoming?.querySelector('[data-collection-grid]');
          if (!incomingGrid) throw new Error('Missing collection');
          const known = new Set([...grid.querySelectorAll('[data-product-id]')].map(card => card.dataset.productId));
          const cards = [...incomingGrid.querySelectorAll('.product-card[data-product-id]')].filter(card => {
            if (known.has(card.dataset.productId)) return false;
            known.add(card.dataset.productId); return true;
          });
          if (!cards.length) throw new Error('No new products');
          const nextLink = incoming.querySelector('[data-collection-next]');
          const following = nextLink ? pageUrl(nextLink.getAttribute('href')).href : '';
          if (following && (following === url.href || visited.has(following))) throw new Error('Repeated next page');
          grid.append(...cards);
          visited.add(url.href);
          next = following;
          if (next) link.href = next;
          else link.remove();
          status.textContent = next ? cards.length + ' produtos carregados.' : 'Você viu todos os produtos.';
          document.dispatchEvent(new CustomEvent('beerclub:products-loaded'));
          succeeded = true;
        } catch (error) {
          if (!disposed) {
            status.textContent = 'Não foi possível carregar os próximos produtos. Tente novamente.';
            retry.hidden = false;
          }
        } finally {
          clearTimeout(timeout);
          loading = false;
          footer.removeAttribute('aria-busy');
          if (succeeded && next && !disposed) observer.observe(footer);
        }
      }
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) load();
      }, { rootMargin: '0px 0px 450px 0px' });
      link.hidden = true;
      retry.addEventListener('click', load);
      feeds.set(feed, () => { disposed = true; controller?.abort(); observer.disconnect(); retry.removeEventListener('click', load); });
      observer.observe(footer);
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    feeds.forEach((dispose, feed) => { if (event.target.contains(feed)) { dispose(); feeds.delete(feed); } });
  });
})();
